import * as pdfjsLib from 'pdfjs-dist';

let configured = false;

export function configurePdfjsWorker(): void {
  if (configured || typeof window === 'undefined') {
    return;
  }

  pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.js',
    import.meta.url,
  ).toString();

  configured = true;
}

export { pdfjsLib };
